import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetPassword } from "../slice/providerAuth";
import ProviderHeader from "../../provider-header/components/index";
import ProviderFooter from "../../provider-footer/components/index";
import { toast } from "react-toastify";

const ProviderResetPassword = () => {
    const { token } = useParams();
    const navigate = useNavigate();

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.providerAuth.loading);


    const handleReset = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) return toast.error("Passwords do not match");

        try {
            const res = await dispatch(resetPassword({ token, newPassword: password })).unwrap();
            toast.success(res, {
                position: "top-right",
                autoClose: 2000,
                style: { fontSize: "0.85rem" },
            });
            navigate("/provider/signin");
        } catch (err) {
            toast.error(err, {
                position: "top-right",
                autoClose: 2000,
                style: { fontSize: "0.85rem" },
            });
        }
    };

    return (
        <>
            <ProviderHeader />
            <main className="overflow-hidden">
                <section className="homepad-signin">  
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 left-panel-signin"
                                style={{
                                    backgroundImage: "url('/assets/images/login-left.jpg')",
                                    backgroundRepeat: "no-repeat"
                                }}>
                                <div className="left-overlay-signin">
                                    <h2 className="montserrat font-weight-bold lh-1 font-size-60">Welcome,  <span className="text-yellow">Professionals</span> & <span className="text-yellow">Educators</span></h2>
                                    <div className="">
                                        <p className="m-0 font-size-14 lh-base">The early years matter—and so does your role in shaping them. The Just Generation Foundation partners with therapists, educators, and healthcare professionals to deliver timely, effective support to families navigating developmental concerns. Join our growing network of licensed experts dedicated to improving outcomes for children ages 2–5. We offer streamlined onboarding, built-in verification, scheduling tools, billing integrations, and a referral-ready platform built with your practice in mind. <br />
                                            🔵 Let’s work together to build a stronger, earlier support system—one child at a time.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 bg-white d-flex align-items-center">
                                <div className="login-form w-100">
                                    <div className="logo text-center mb-4">
                                        <img src="/assets/images/logo-login.png" className="img-fluid" />
                                    </div>
                                    <h3 className="font-weight-bold montserrat text-primary font-size-34 mb-3 lh-1 text-center">Reset Your Password</h3>
                                    <p className="text-center text-dark">Lorem Ipsum is simply dummy text of the printing!</p>
                                    <form onSubmit={handleReset} className="mt-3 mt-xl-4 pt-xl-2 d-block">
                                        <div className="mb-3">
                                            <label className="form-label text-primary mb-1 font-weight-semibold">New Password</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label text-primary mb-1 font-weight-semibold">Confirm Password</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <button type="submit" className="btn btn-yellow w-100 mb-3 font-weight-bold font-size-18" disabled={loading}>
                                        {loading ? "Resetting..." : "Reset Password"}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <ProviderFooter />
            </main>
        </>
    );
};

export default ProviderResetPassword;
